module.exports = __webpack_public_path__ + "img/chevron-down.454de152.svg";